import { Link } from "react-router-dom";
import FadeIn from "@/components/FadeIn";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center" data-testid="notfound-page">
      <div className="container-narrow text-center py-24">
        <FadeIn>
          <p className="overline">404 · Off the path</p>
          <h1 className="mt-6 font-serif text-5xl lg:text-7xl text-moss font-light leading-tight tracking-tight">
            The trail doesn't lead here.
          </h1>
          <p className="mt-8 text-coal/70 text-lg leading-[1.85]">
            Let's get you back to the open gate.
          </p>
          <Link to="/" className="btn-primary mt-10 inline-flex" data-testid="notfound-home-btn">Return home</Link>
        </FadeIn>
      </div>
    </div>
  );
}
